export default "__VITE_ASSET__7b6e725f__"